export default function ReporteCard({ title, children }) {
    return (
        <div className="card-panel">
            <h3>{title}</h3>
            {children}
        </div>
    );
}